









































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateCity from "./createcity.vue";
import EditCity from "./editcity.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageCityRequest extends PageRequest {
  keyword: string;
  parentId: number;
}

@Component({
  components: { CreateCity, EditCity },
})
export default class City extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  //编辑
  edit() {
    this.editModalShow = true;
  }

  pagerequest: PageCityRequest = new PageCityRequest();
  creationTime: Date[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  treedata: [] = [];
  itemId: string = "0";
  splitnum: number = 0.15;
  get list() {
    return this.$store.state.city.list;
  }
  get loading() {
    return this.$store.state.city.loading;
  }
  async itemtree() {
    await this.$store
      .dispatch("city/getFirstNodeTree")
      .then((val) => {
        this.treedata = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  create() {
    this.createModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("city/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("city/setPageSize", pagesize);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.parentId = item[0].id;
    }
    this.$store.commit("city/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("city/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "city/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.city.pageSize;
  }
  get totalCount() {
    return this.$store.state.city.totalCount;
  }
  get currentPage() {
    return this.$store.state.city.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Name"),
      key: "fullName",
      width: 240,
      tree: true,
    },
    {
      title: this.L("Encode"),
      key: "encode",
      width: 130,
    },
    {
      title: this.L("SimpleSpelling"),
      key: "simpleSpelling",
      width: 180,
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
    },
    {
      title: this.L("IsEnable"),
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Id"),
      key: "id",
      width: 130,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('cityEdit');
        let edit = this.checkButtonAuth('cityDel');
        return h("div", [
          del ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("city/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "city/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    this.itemtree();
  }
}
